import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 10h14","key":"svg-0"}],["path",{"d":"M5 14h14","key":"svg-1"}],["path",{"d":"M5 19l14 -14","key":"svg-2"}]]

const IconEqualNot = createReactComponent('outline', 'equal-not', 'EqualNot', __iconNode);

export default IconEqualNot;